import { components } from "@/api-schema";

type AppRole = components["schemas"]["AppRole"];

export function filterAppRolesWithoutAttributes(appRoles: AppRole[] | undefined): AppRole[] {
  return appRoles?.filter((role) => !role.attribute) || [];
}
